// Copyright 2026 NXGN Management, LLC. All Rights Reserved.
import { Flex as NextGenFlex, Tag, FormItem } from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

export const Flex = styled(NextGenFlex)`
  min-width: 0;
  flex: 1;
`

export const Wrapper = styled.div`
  overflow-wrap: 'anywhere';
`

export const NextGenTag = styled(Tag)`
  flex-shrink: 0;
  margin-top: 2px;
  align-self: 'flex-start';
`

export const CustomTag = styled(Tag)`
  flex-shrink: 0;
`

export const PracticeFormItem = styled(FormItem)`
  .nextgen-select-selector {
    .nextgen-select-selection-wrap {
      padding-left: 20px;
    }
  }
`
